import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BecomePartner = lazy(() => import("@/pages/BecomePartner"));

export const Route = createFileRoute("/bli-partner/")({
  head: () => seoHead("/bli-partner"),
  component: () => <BecomePartner />,
});
